import { Check, Minus, ArrowUpRight } from "lucide-react";
import { Reveal } from "./primitives";
import { TIERS, TERMINAL_URL } from "./orderFlowData";

const Cell = ({ v, strong }) => {
  if (v === true) return <Check size={16} className={strong ? "text-[#BACD1C]" : "text-[#9DA3AE]"} />;
  if (v === false) return <Minus size={16} className="text-white/20" />;
  return <span className={`font-mono text-[11px] uppercase tracking-[0.14em] ${strong ? "text-[#ECEBE4]" : "text-[#7D8390]"}`}>{v}</span>;
};

export const GuestVsFree = () => (
  <section id="free-account" data-testid="guest-vs-free" className="relative bg-[#0A0A0A] py-24 md:py-28">
    <div className="mx-auto max-w-[1100px] px-6 md:px-12">
      <Reveal className="max-w-2xl">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#7D8390]">Guest vs free account</p>
        <h2 className="mt-4 font-display text-3xl font-semibold leading-[1.02] tracking-[-0.03em] text-[#ECEBE4] md:text-4xl">
          Free either way. <span className="text-[#7D8390]">Live once you sign up.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="mt-10 overflow-x-auto">
        <table className="w-full min-w-[560px] border-collapse">
          <thead>
            <tr className="border-b border-white/[0.10] font-mono text-[10px] uppercase tracking-[0.2em]">
              <th className="py-4 text-left font-normal text-[#5A6170]">Feature</th>
              <th className="w-36 py-4 text-left font-normal text-[#7D8390]">Guest</th>
              <th className="w-44 border-t-2 border-[#BACD1C]/70 bg-white/[0.025] px-4 py-4 text-left font-normal text-[#ECEBE4]">Free account</th>
            </tr>
          </thead>
          <tbody>
            {TIERS.map((t, i) => (
              <tr key={t.row} data-testid={`tier-row-${i}`} className="border-b border-white/[0.06]">
                <td className="py-4 pr-4 font-mono text-xs text-[#9DA3AE]">{t.row}</td>
                <td className="py-4"><Cell v={t.guest} /></td>
                <td className="bg-white/[0.025] px-4 py-4"><Cell v={t.free} strong /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Reveal>
      <Reveal delay={0.15} className="mt-10 flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-mono text-[11px] text-[#7D8390]">Email + password or Google · sign up right from the terminal card · no card required</p>
        <a href={TERMINAL_URL} data-testid="guest-vs-free-cta" className="group inline-flex w-full items-center justify-center gap-2 bg-[#BACD1C] px-7 py-4 font-mono text-sm uppercase tracking-[0.15em] text-black transition-[background-color,transform] duration-300 hover:bg-[#ECEBE4] active:scale-[0.98] sm:w-auto">
          Create free account <ArrowUpRight size={17} />
        </a>
      </Reveal>
      <p data-testid="nfa-note" className="mt-12 border-t border-white/[0.06] pt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-[#5A6170]">
        Real data, no profit claims · This isn't financial advice
      </p>
    </div>
  </section>
);
